import { render, staticRenderFns } from "./SplitScreenContrast.vue?vue&type=template&id=63c2fbb2&scoped=true"
import script from "./SplitScreenContrast.vue?vue&type=script&lang=js"
export * from "./SplitScreenContrast.vue?vue&type=script&lang=js"
import style0 from "./SplitScreenContrast.vue?vue&type=style&index=0&id=63c2fbb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2fbb2",
  null
  
)

export default component.exports